export const environment = {
  tealiumEnvironment: 'qa',
  environmentRedirect: true,
  flagEnvironment: 'stg',
  testEnvironment: true,
  production: false,
  mock: false,
  pseOff: false,
  retakeOff: true,
  tealium: {
    enable: true
  },
  account: 'adl',
  profile: 'avv',
  baseUrl: 'https://rb-pasivo-stg-api-avvillas.avaldigitallabs.com',
  baseUrlWs: 'wss://s0t5mc4x8d.execute-api.us-east-2.amazonaws.com/stg',
  baseUrlWsPse: 'wss://dvd9ri2e01.execute-api.us-east-2.amazonaws.com/stg',
  canonicalBaseUrl:
    'https://rb-pasivo-stg-cdt-front.avaldigitallabs.com/abrir-cdt-avvillas',
  recatpchaEnterpriseSource:
    'https://www.google.com/recaptcha/enterprise.js?render=',
  recaptchaEnterpriseKey: '6LcZG1coAAAAAB2xUhR7jy-LTZ0CzTo1TgTIsOQe',
  baseUrlBiometric:
    'https://3u8onsrd53.execute-api.us-east-2.amazonaws.com/stg',
  appSyncConfigProducts: {
    aws_appsync_graphqlEndpoint:
      'https://xmd2wfzh4fdtjivr7icax33dai.appsync-api.us-east-2.amazonaws.com/graphql',
    aws_appsync_region: 'us-east-2',
    aws_appsync_authenticationType: 'userPool'
  },
  assetsUrl: 'https://d2xin6o0shixgy.cloudfront.net',
  SDKconfigcatKey:
    'configcat-sdk-1/msfcCERdNkKIFkIDUqaEOg/FofM7wQ8CkiG-NYhaLKkSA'
};
